import { atomWithStorage } from "jotai/utils";

export const layersPanelInitialWidth = "280px";

export const layersPanelWidthAtom = atomWithStorage<string>(
  "composable_layersPanelWidth",
  layersPanelInitialWidth,
  undefined,
  {
    getOnInit: true,
  },
);
